import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    authinfo: null,
    userinfo: {
        isAuthenticated: false,
        unreadCount: 0, // messages
        isPhoneNumberConfirmed: false,
        totalNotifications: 0,
        id: null,
        email: null,
        firstName: null,
        lastName: null,
        name: null,
        isCompleted: false,
        isSuperAdmin: false,
    },
    allAppointments: [],
    allMessages: [],
    uniqueString: ""
}
export const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        adduser: (state, action) => {
            state.authinfo = action.payload.authinfo
            state.userinfo.id = action.payload.userinfo.id
            state.userinfo.isAuthenticated = action.payload.userinfo.isAuthenticated
            state.userinfo.unreadCount = action.payload.userinfo.unreadCount
            state.userinfo.isPhoneNumberConfirmed = action.payload.userinfo.isPhoneNumberConfirmed
            state.userinfo.email = action.payload.userinfo.email
            state.userinfo.firstName = action.payload.userinfo.firstName
            state.userinfo.lastName = action.payload.userinfo.lastName
            state.userinfo.name = action.payload.userinfo.name
            state.userinfo.isSuperAdmin = action.payload.userinfo.isSuperAdmin
            state.userinfo.isCompleted = action.payload.userinfo.isCompleted
            state.userinfo.totalNotifications = action.payload.userinfo.totalNotifications
        },

        addAppointments: (state, action) => {
            state.allAppointments = action.payload.allAppointments
            state.userinfo.totalNotifications = action.payload.totalNotifications
        },
        changeApptStatus: (state, action) => {
            const updated_appts = state.allAppointments.map((appt) => {
                let obj = { ...appt }
                if (appt.id === action.payload.apptID) {
                    obj.status = action.payload.apptStatus
                }
                return obj
            })
            return {
                ...state,
                allAppointments: updated_appts
            }
        },
        addCommentInAppointment: (state, action) => {
            const updated_apptssss = state.allAppointments.map((appt) => {
                let obj = { ...appt }
                if (obj.id === action.payload.apptId) {
                    obj.comments = [action.payload.newComment, ...obj.comments]
                }
                return obj
            })
            return {
                ...state,
                allAppointments: updated_apptssss
            }
        },
        updateAppt: (state, action) => {
            const updated_apptssss = state.allAppointments.map((appt) => {
                let obj = { ...appt }
                if (obj.id === action.payload.apptId) {
                    obj = action.payload.appt
                }
                return obj
            })
            return {
                ...state,
                allAppointments: updated_apptssss
            }
        },
        updateNotification: (state) => {
            state.userinfo.totalNotifications = 0
        },

        updateNotificationagain: (state) => {
            state.userinfo.totalNotifications = state.userinfo.totalNotifications + 1
        },

        getAllMessages: (state, action) => {

            const all_Messages = action.payload.allMessages
            const newArray = all_Messages.map((obj, index) => ({
                ...obj,
                active: false,
            }));
            // newArray[0].active = true

            return {
                ...state,
                allMessages: newArray,
                userinfo: {
                    ...state.userinfo,
                    unreadCount: action.payload.unreadCount,
                    totalNotifications: action.payload.totalNotifications
                },

            }
        },

        // this functions used to update the single count when opened but now we call it from backend
        updateSingleChatUnreadCount: (state, action) => {
            const selectedConversationId = parseInt(action?.payload?.selectedConversationId);

            const updated_messages = state.allMessages.map((msg) => {
                let obj = { ...msg };

                // along with the business id, also check conversation id because different conversation of same businesses have same business id
                if (obj.business.id === action.payload.businessid && (!parseInt(obj?.chatSLBConversation?.id) || selectedConversationId === obj?.chatSLBConversation?.id)) {
                    obj.unreadCount = 0;
                }
                return obj; // state conversation count already is 0, we need new from backend
            })

            return {
                ...state,
                allMessages: updated_messages,
                userinfo: {
                    ...state.userinfo,
                    unreadCount: action.payload.unreadCount,
                },

            }
        },

        toggleActiveChat: (state, action) => {

            const chatSLBConversationId = parseInt(action?.payload?.chatSLBConversationId) || 0;
            const businessId = parseInt(action?.payload?.businessId);
            let found = false; // Introduce a flag


            // If the chatConversationId exists than compare both id and conversationId else only business id
            const newArray = state.allMessages.map((obj, index) => {
                const isSameBusiness = obj.business.id === businessId;
                const hasConversation = obj?.chatSLBConversation?.id !== undefined && obj?.chatSLBConversation?.id !== null;
                const isSameConversation = hasConversation && obj.chatSLBConversation.id === chatSLBConversationId;
                const isActive = !found && isSameBusiness && (hasConversation ? isSameConversation : !chatSLBConversationId);

                if (isActive) {
                    found = true; // Update the flag
                }

                return {
                    ...obj,
                    active: isActive,
                };
            });


            return {
                ...state,
                allMessages: newArray,
            }
        },

        // Deactivates all the business messages
        toggleDeactivateChat: (state, action) => {
            const newArray = state.allMessages.map((obj) => ({
                ...obj,
                active: false,
            }));
            return {
                ...state,
                allMessages: newArray,
            }
        },

        resetallMessages: (state, action) => {
            const newArray = state.allMessages.map((obj, index) => ({
                ...obj,
                active: false, // Set 'active' to true for the first index and false for the rest
            }));
            return {
                ...state,
                allMessages: newArray,
            }
        },

        getAllMessagesWithLatestMessage: (state, action) => {
            const selectedConversationId = action?.payload?.selectedConversationId;
            // then we check if the active businessid is equal to latest message businessid
            const actveMessage = state.allMessages.find(message => message.active); // these are conversations

            if (actveMessage) {

                // find if the active business is same as the last msg recieved business,
                if (actveMessage.business.id === parseInt(action.payload.latestMessage.businessId)
                ) {

                    const all_Messages = action.payload.allMessages;
                    const newArray = all_Messages.map((obj, index) => {

                        let isActive;
                        if (selectedConversationId) {
                            isActive = actveMessage?.business?.id === obj?.business?.id && obj?.chatSLBConversation?.id === selectedConversationId
                        }
                        else {
                            isActive = actveMessage?.business?.id === obj?.business?.id && obj?.chatSLBConversation === null;
                        }

                        return {
                            ...obj,
                            active: isActive,
                        };
                    });

                    return {
                        ...state,
                        allMessages: newArray,
                        userinfo: {
                            ...state.userinfo,
                            unreadCount: action.payload.unreadCount,
                            totalNotifications: action.payload.totalNotifications
                        },
                    }
                }
                else {
                    // if conversation id exist than active only that one which is clicked by checking both business and converstion id else only check businss id
                    const allNewMessages = action.payload.allMessages
                    const newArasdfasdfray = allNewMessages.map((obj, index) => {
                        let isActive;
                        if (selectedConversationId) {
                            isActive = actveMessage?.business?.id === obj?.business?.id && obj?.chatSLBConversation?.id === selectedConversationId
                        }
                        else {
                            isActive = actveMessage?.business?.id === obj?.business?.id && obj?.chatSLBConversation === null;
                        };
                        return {
                            ...obj,
                            active: isActive,
                        }

                    });

                    return {
                        ...state,
                        allMessages: newArasdfasdfray,
                        userinfo: {
                            ...state.userinfo,
                            unreadCount: action.payload.unreadCount,
                            totalNotifications: action.payload.totalNotifications
                        },

                    }
                }
            }
            else {
                const all_NewMessages = action.payload.allMessages
                const newNArray = all_NewMessages.map((obj, index) => ({
                    ...obj,
                    active: false,
                }));
                // newNArray[0].active = true
                return {
                    ...state,
                    allMessages: newNArray,
                    userinfo: {
                        ...state.userinfo,
                        unreadCount: action.payload.unreadCount,
                        totalNotifications: action.payload.totalNotifications
                    },
                }
            }
        },


    },
})

// Action creators are generated for each case reducer function
export const {
    adduser,
    addAppointments,
    changeApptStatus,
    addCommentInAppointment,
    updateAppt,
    updateNotification,
    updateNotificationagain,
    getAllMessages,
    updateSingleChatUnreadCount,
    toggleActiveChat,
    toggleDeactivateChat,
    resetallMessages,
    getAllMessagesWithLatestMessage

} = AuthSlice.actions

export default AuthSlice.reducer